import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import ActionContainer from 'components/ActionContainer/ActionContainer';
import TextInput from 'components/TextInput/TextInput';
import { TRADES } from 'constants/trades';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  description: {
    padding: theme.spacing(1, 1, 2),
    color: theme.palette.text.secondary,
  },
  codeCell: {
    display: 'flex',
    flexDirection: 'column',
  },
  code: {
    fontWeight: 600,
  },
  name: {
    color: theme.palette.text.secondary,
  },
  row: {
    padding: theme.spacing(0.5, 1),
  },
}));

export const ProjectTradeRatesSection = ({
  open,
  setOpen,
  loading,
  hourlyCosts,
  onChangeHourlyCost,
  inherited,
  changedFromParentWarningOpen,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <ActionContainer
      title={t('project_dialog.section_trade_hourly_costs')}
      closable
      open={open}
      setOpen={setOpen}
    >
      {inherited && !changedFromParentWarningOpen && (
        <Grid item xs={12}>
          <Alert severity="info" variant="outlined">
            <AlertTitle>{t('project_dialog.alert_notice_title')}</AlertTitle>
            {t('project_dialog.trade_hourly_costs_inherited_from_parent')}
          </Alert>
        </Grid>
      )}
      {inherited && changedFromParentWarningOpen && (
        <Grid item xs={12}>
          <Alert severity="warning" variant="outlined">
            <AlertTitle>{t('project_dialog.alert_warning_title')}</AlertTitle>
            {t('project_dialog.alert_trade_hourly_costs_changed_from_parent')}
          </Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.description}>
          {t('project_dialog.trade_hourly_costs_description')}
        </Typography>
      </Grid>
      {TRADES.map((trade) => (
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="center"
          className={classes.row}
          key={trade.code}
        >
          <Grid item xs={7} sm={8} className={classes.codeCell}>
            <Typography className={classes.code}>{trade.code}</Typography>
            <Typography variant="body2" className={classes.name}>
              {trade.name}
            </Typography>
          </Grid>
          <Grid item xs={5} sm={4}>
            <TextInput
              fullWidth
              type="number"
              adornment="€/h"
              value={hourlyCosts[trade.code] ?? ''}
              onChange={(event) =>
                onChangeHourlyCost(trade.code, event.target.value)
              }
              disabled={loading}
              inputProps={{ min: 0, step: '0.01' }}
            />
          </Grid>
        </Grid>
      ))}
    </ActionContainer>
  );
};

ProjectTradeRatesSection.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  loading: PropTypes.bool,
  hourlyCosts: PropTypes.object,
  onChangeHourlyCost: PropTypes.func.isRequired,
  inherited: PropTypes.bool,
  changedFromParentWarningOpen: PropTypes.bool,
};

ProjectTradeRatesSection.defaultProps = {
  open: false,
  setOpen: () => {},
  loading: false,
  hourlyCosts: {},
  inherited: false,
  changedFromParentWarningOpen: false,
};

export default ProjectTradeRatesSection;
